import { render, staticRenderFns } from "./PasswordChangeReminderModal.vue?vue&type=template&id=6096721d&scoped=true"
import script from "./PasswordChangeReminderModal.vue?vue&type=script&lang=js"
export * from "./PasswordChangeReminderModal.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeReminderModal.vue?vue&type=style&index=0&id=6096721d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096721d",
  null
  
)

export default component.exports